<template>
  <div class="modal fade" id="modalVerArchivos" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Archivos Subidos</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center" v-if="current">
          <p v-if="current.archivo || current.archivo_2" class="mb-4">Archivos adjuntos:</p>
          
          <div class="row w-100 mx-0">
            <!-- Archivo 1 -->
            <div v-if="current.archivo" :class="{'col-12': !current.archivo_2, 'col-6': current.archivo_2}" class="px-2 mb-3">
              <div v-if="esImagen(current.archivo)" class="d-flex flex-column align-items-center justify-content-between p-3 h-100" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6;">
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-invoice mr-1"></i> Factura
                </div>
                <a target="_blank" :href="current.archivo" class="d-flex w-100 align-items-center justify-content-center h-100" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'" title="Click para abrir imagen">
                  <img :src="current.archivo" alt="Vista previa de factura" style="max-width: 100%; max-height: 200px; border-radius: 6px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;">
                </a>
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ getFileName(current.archivo) }}
                </span>
              </div>
              <div v-else class="d-flex flex-column align-items-center justify-content-between p-3 h-100" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6;">
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-invoice mr-1"></i> Factura
                </div>
                <a target="_blank" :href="current.archivo" class="d-flex flex-column w-100 align-items-center justify-content-center h-100 text-dark" style="transition: transform 0.2s; text-decoration: none;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'" title="Click para abrir archivo">
                  <i class="fas fa-file-invoice fa-4x mb-2"></i>
                </a>
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ getFileName(current.archivo) }}
                </span>
              </div>
            </div>

            <!-- Archivo 2 -->
            <div v-if="current.archivo_2" :class="{'col-12': !current.archivo, 'col-6': current.archivo}" class="px-2 mb-3">
              <div v-if="esImagen(current.archivo_2)" class="d-flex flex-column align-items-center justify-content-between p-3 h-100" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6;">
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-alt mr-1"></i> Anexo / Contraseña
                </div>
                <a target="_blank" :href="current.archivo_2" class="d-flex w-100 align-items-center justify-content-center h-100" style="transition: transform 0.2s;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'" title="Click para abrir anexo">
                  <img :src="current.archivo_2" alt="Vista previa de anexo" style="max-width: 100%; max-height: 200px; border-radius: 6px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;">
                </a>
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ getFileName(current.archivo_2) }}
                </span>
              </div>
              <div v-else class="d-flex flex-column align-items-center justify-content-between p-3 h-100" style="background-color: #f8f9fa; border-radius: 8px; border: 1px dashed #dee2e6;">
                <div class="mb-2 text-dark font-weight-bold w-100 text-center" style="font-size: 0.9em;">
                  <i class="fas fa-file-alt mr-1"></i> Anexo / Contraseña
                </div>
                <a target="_blank" :href="current.archivo_2" class="d-flex flex-column w-100 align-items-center justify-content-center h-100 text-dark" style="transition: transform 0.2s; text-decoration: none;" onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'" title="Click para abrir anexo">
                  <i class="fas fa-file-alt fa-4x mb-2"></i>
                </a>
                <span class="mt-3 text-muted w-100 text-center" style="word-break: break-all; font-size: 0.85em; font-weight: 500;">
                  {{ getFileName(current.archivo_2) }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-dark" data-dismiss="modal" type="button">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConsultaArchivoScanSubidoModal',
  props: {
    current: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    esImagen(url) {
      if (!url) return false;
      let filename = '';
      if (typeof url === 'string') {
        filename = url;
      } else if (url instanceof File) {
        filename = url.name;
      } else {
        return false;
      }
      const extension = filename.split('.').pop().toLowerCase().split('?')[0];
      return ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp'].includes(extension);
    },
    getFileName(url) {
      if (!url) return 'Archivo';
      if (typeof url !== 'string') {
        if (url instanceof File) return url.name;
        return 'Archivo';
      }
      try {
        const decoded = decodeURIComponent(url);
        const parts = decoded.split('/').pop().split('?')[0];
        return parts || 'Archivo';
      } catch (e) {
        return 'Archivo';
      }
    }
  }
};
</script>
